import { render, staticRenderFns } from "./areaWarn_page.vue?vue&type=template&id=4f8680a0&scoped=true"
import script from "./areaWarn_page.vue?vue&type=script&lang=js"
export * from "./areaWarn_page.vue?vue&type=script&lang=js"
import style0 from "./areaWarn_page.vue?vue&type=style&index=0&id=4f8680a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8680a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8680a0')) {
      api.createRecord('4f8680a0', component.options)
    } else {
      api.reload('4f8680a0', component.options)
    }
    module.hot.accept("./areaWarn_page.vue?vue&type=template&id=4f8680a0&scoped=true", function () {
      api.rerender('4f8680a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/areaWarn_page.vue"
export default component.exports